module.exports = "/_next/static/images/technology-e62502d89d181869ff0faa7281e99e33.webp";